import { useState } from 'react';
import { updateJobPayment } from '../api/jobPayments';
import type { UpdateJobPaymentRequest, JobPayment } from '../types/jobPayment';

/**
 * Hook for updating an existing job payment
 */
export function useUpdateJobPayment() {
  const [isUpdating, setIsUpdating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const update = async (
    jobId: number,
    paymentId: number,
    data: UpdateJobPaymentRequest
  ): Promise<JobPayment | null> => {
    setIsUpdating(true);
    setError(null);
    try {
      const payment = await updateJobPayment(jobId, paymentId, data);
      return payment;
    } catch (err) {
      const error = err as { response?: { data?: { message?: string } } };
      setError(error.response?.data?.message || 'Failed to update job payment');
      return null;
    } finally {
      setIsUpdating(false);
    }
  };

  return {
    update,
    isUpdating,
    error,
  };
}
